import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'adc-button',
  templateUrl: './adc-button.component.html',
  styleUrls: ['./adc-button.component.scss'],
  standalone: false
})
export class AdcButtonComponent {
  @Input() data:any;
  @Output() clickEvent: EventEmitter<any> = new EventEmitter<any>;

  btnClick() {
    this.clickEvent.emit('Clicked');
  }
}
